var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "#3B968B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3038_6893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7117 12.7895C21.0961 12.3801 21.0961 11.7164 20.7117 11.307C20.3273 10.8977 19.7041 10.8977 19.3197 11.307L13.5315 17.4715L11.6803 15.5C11.2959 15.0906 10.6727 15.0906 10.2883 15.5C9.9039 15.9094 9.9039 16.5731 10.2883 16.9824L12.8334 19.693C13.0261 19.8982 13.2788 20.0005 13.5314 20C13.784 20.0006 14.0368 19.8982 14.2295 19.693L20.7117 12.7895Z",
    fill: "#FFF6EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3038_6893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 9.00015,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.7390cb4e33c2e6768deaf81e244beb9a.svg";
export { ForwardRef as ReactComponent };